import $ from 'jquery';
import config from '../../../config';

// Upload attachment
export function upload_files( data ){
	return dispatch => {
		
		$.ajax({
			method: 'POST',
			dataType : 'json',
			url: config.apiurl + 'admin_leaves/',
			data: data,
			processData: false,
			contentType: false
		}).then(function ( response ) {
			dispatch({
				type: "LEAVE_UPLOADED_ATTACHMENT",
				leave_admin: response
			})
		})

	}

}


export function get_users(){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'admin_leaves/',
			data: {
                method: 'ADM_GET_USERS'
            }
		})
		.then(function (response) {
			dispatch({
				type: "ADM_GET_USERS",
				leave_admin: response
			})
		})

	}
}

export function get_leave_type(){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'admin_leaves/',
			data: {
                method: 'ADM_GET_LEAVE_TYPE'
            }
		})
		.then(function (response) {
			dispatch({
				type: "ADM_GET_LEAVE_TYPE",
				leave_admin: response
			})
		})

	}
}


export function save_leave( data ){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'admin_leaves/',
			data: {
				method: 'ADM_SAVE_LEAVES',
				data: data
            }
		})
		.then(function (response) {
			dispatch({
				type: "ADM_SAVE_LEAVES",
				leave_admin: response
			})
		})

	}
}

export function get_leave(){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'admin_leaves/',
			data: {
				method: 'ADM_GET_LEAVE',
            }
		})
		.then(function (response) {
			dispatch({
				type: "ADM_GET_LEAVE",
				leave_admin: response
			})
		})

	}
}

export function delete_leave( leave_id){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'admin_leaves/',
			data: {
				method: 'ADM_DELETE_LEAVE',
				leave_id: leave_id
            }
		})
		.then(function (response) {
			dispatch({
				type: "ADM_DELETE_LEAVE",
				leave_admin: response
			})
		})

	}
}

export function set_leave_type( leave_id, leave_type_id ){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'admin_leaves/',
			data: {
				method: 'ADM_SET_LEAVE_TYPE',
				leave_id: leave_id,
				leave_type_id: leave_type_id
            }
		})
		.then(function (response) {
			dispatch({
				type: "ADM_SET_LEAVE_TYPE",
				leave_admin: response
			})
		})

	}
}

export function set_leave_dates( leave_id, from, to ){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'admin_leaves/',
			data: {
				method: 'ADM_SET_LEAVE_DATES',
				leave_id: leave_id,
				from_date: from,
				to_date: to
            }
		})
		.then(function (response) {
			dispatch({
				type: "ADM_SET_LEAVE_DATES",
				leave_admin: response
			})
		})

	}
}


export function set_document( leave_id, attach ){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'admin_leaves/',
			data: {
				method: 'ADM_SET_LEAVE_DOC',
				leave_id: leave_id,
				attach: attach
            }
		})
		.then(function (response) {
			dispatch({
				type: "ADM_SET_LEAVE_DOC",
				leave_admin: response
			})
		})

	}
}


// WEBPACK FOOTER //
// ./src/pages/leaves_admin/actions/leaves.action.js